import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle() {
    this.inputTarget.classList.toggle("masked-field__input")
    this.showIconTarget.classList.toggle("hidden")
    this.hideIconTarget.classList.toggle("hidden")
  }
}
